import { MakeAppBarGuardObjectTypeFromMatcher, MakeAppBarGuardTypeFromMatcher } from '../type';
import {
  makefn as makeIsMqUpFn,
} from '../isMqUp';
import {
  fn as isExpandedSectionFn,
} from '../isExpandedSection';

export const name = 'shouldLogoExpand';

export const makefn: MakeAppBarGuardTypeFromMatcher = (matcher) => {
  const isMqUpFn = makeIsMqUpFn(matcher);
  return (context, event) => {
    const isMqUp = isMqUpFn(context, event);
    const isExpandedSection = isExpandedSectionFn(context, event);
    return isMqUp && isExpandedSection;
  };
};

export const makeGuard: MakeAppBarGuardObjectTypeFromMatcher = (matcher) => ({
  [name]: makefn(matcher),
});

export default makeGuard;
